module.exports = __webpack_public_path__ + "images/stickers/pete-shipped.13b817ebec2282c5a7ab.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/stickers/pete-shipped.png
// module id = dm1F
// module chunks = 2